import React from 'react';
import { Typography } from 'antd';

/**
 * The window a tab is reporting on.
 *
 * Shown per tab rather than once in the header, because not every tab uses it.
 * The Overview's cards work to their own fixed periods -- month to date, last
 * month, this week -- and Recruitment has a window of 30 days either side of
 * today. A range printed at the top of the page would be claiming to govern
 * those too.
 */
export default function WindowNote({ from, to }) {
  if (!from || !to) return null;
  return (
    <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 10 }}>
      {from} to {to}
    </Typography.Text>
  );
}
